import React, {Fragment} from "react";
import {formatAsCurrency} from "../index";
import isEmpty from 'lodash/isEmpty';

const OrderLine = ({line, idx, orderData, includeTax}) => {
    return (
        <tr key={`product_${idx}`}>
            <td>
                <img
                    src={line.item?.image}
                    alt={line.item?.name ? line.item?.name : ''}
                    className="w-100"
                />
            </td>
            <td className="overflow-anywhere">
                <p className="mb-0 font-weight-bold">
                    {line.item?.name}
                </p>
                {line.item?.sku && (
                    <p className="mb-0">{line.item?.sku}</p>
                )}
                {!isEmpty(line.item?.variantOptions) && (
                    <p className="mb-2">
                        {Object.values(
                            line.item.variantOptions
                        ).map((v, idx) => (
                            <Fragment key={idx}>
                                <span className="font-weight-bold">
                                    {v.name}:
                                </span>{' '}
                                {v.displayValue}{' '}
                            </Fragment>
                        ))}
                    </p>
                )}
                {line.line && (
                    <p className="mb-0">
                        {formatAsCurrency(
                            includeTax
                                ? line.priceIncTaxBeforeDiscount
                                : line.priceExcTaxBeforeDiscount,
                            orderData?.currency
                        )}
                    </p>
                )}
            </td>
            <td className="text-right">{line.quantity}</td>
            <td className="text-right">
                <p className="mb-0">
                    {line?.promotions
                        ? formatAsCurrency(
                            line.promotions?.reduce(
                                (acc, curVal) => {
                                    return (
                                        acc +
                                        (includeTax
                                            ? curVal?.discount
                                                ?.incTax
                                            : curVal?.discount
                                                ?.excTax)
                                    )
                                },
                                0
                            ),
                            orderData?.currency
                        )
                        : formatAsCurrency(
                            0,
                            orderData?.currency
                        )}
                </p>
            </td>
            <td className="text-right">
                {formatAsCurrency(
                    includeTax
                        ? line?.linePriceTotal?.incTax
                        : line?.linePriceTotal?.excTax,
                    orderData?.currency
                )}
            </td>
        </tr>
    )
}

export default OrderLine